document.addEventListener('DOMContentLoaded', function () {
    const popup = document.querySelector('.mobile-color-popup');
    if (!popup) return;

    const openBtn = document.querySelector('.mobile-color-btn');
    const overlay = popup.querySelector('.mobile-color-overlay');
    const doneBtn = popup.querySelector('.mobile-color-done');
    const closeBtn = popup.querySelector('.mobile-color-close');

    const selectedText = document.querySelector('.mobile-selected-color');
    const currentColor = popup.querySelector('.mobile-current-color strong');
    const originalSwatch = document.querySelector('.swatch-color');
    const popupImage = popup.querySelector('.mobile-color-image');

    const colorBtn = document.querySelector('.mobile-color-btn');
    const colorBtnLabel = colorBtn?.querySelector('.mobile-color-btn-label');

    function updateButtonState(isAvailable) {
        if (!doneBtn) return;

        doneBtn.disabled = !isAvailable;
        doneBtn.classList.toggle('disabled', !isAvailable);

        const btnText = doneBtn.querySelector('span');

        if (btnText) {
            btnText.textContent = isAvailable
                ? 'Choose color'
                : 'Out of stock';
        }
    }

    function updateColorButton(swatch) {
        if (!colorBtn || !swatch) return;

        const swatchInner = swatch.querySelector('.mobile-swatch-inner');

        if (colorBtnLabel) {
            colorBtnLabel.textContent = 'CHANGE COLOR';
        }

        let preview = colorBtn.querySelector('.mobile-selected-swatch');

        if (!preview) {
            preview = document.createElement('span');
            preview.className = 'mobile-selected-swatch';

            colorBtn.insertBefore(
                preview,
                colorBtn.querySelector('.btn-arrow')
            );
        }

        preview.style.cssText = swatchInner.style.cssText;
    }

    function refreshMobileSwatches() {

        if (!window.productData) return;

        const optionSelectors = document.querySelectorAll('.single-option-selector');

        const selectedOptions = [];

        optionSelectors.forEach(function (select) {
            selectedOptions.push(select.value);
        });

        const colorIndex = parseInt(document.querySelector('.swatch-color').dataset.optionIndex, 10);

        document.querySelectorAll('.mobile-swatch').forEach(function (swatch) {

            const color = swatch.dataset.value;

            const options = [...selectedOptions];
            options[colorIndex] = color;

            const variant = window.productData.variants.find(function (v) {

                return (
                    v.option1 === options[0] &&
                    (options.length < 2 || v.option2 === options[1]) &&
                    (options.length < 3 || v.option3 === options[2])
                );

            });

            const available = variant ? variant.available : false;

            swatch.dataset.available = available;

            swatch.classList.toggle('soldout', !available);

            let cross = swatch.querySelector('.crossed-out');

            if (!available && !cross) {

                cross = document.createElement('img');
                cross.src = window.soldoutIcon;
                cross.className = 'crossed-out';
                cross.alt = 'Sold out';

                swatch.querySelector('.mobile-swatch-inner').appendChild(cross);

            }

            if (available && cross) {
                cross.remove();
            }

            if (swatch.classList.contains('active')) {
                updateButtonState(available);
            }

        });

    }

    if (openBtn) {
        openBtn.addEventListener('click', function () {
            refreshMobileSwatches();
            popup.classList.add('active');
        });
    }

    if (overlay) {
        overlay.addEventListener('click', function () {
            popup.classList.remove('active');
        });
    }

    if (doneBtn) {
        doneBtn.addEventListener('click', function () {
            if (!doneBtn.disabled) {
                popup.classList.remove('active');
            }
        });
    }

    if (closeBtn) {
        closeBtn.addEventListener('click', function () {
            popup.classList.remove('active');
        });
    }

    document.querySelectorAll('.mobile-swatch').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
            const value = this.dataset.value;
            const variantImg = this.dataset.variantImg;
            const isAvailable = this.dataset.available === 'true';

            document.querySelectorAll('.mobile-swatch').forEach(function (item) {
                item.classList.remove('active');
            });

            this.classList.add('active');

            if (selectedText) {
                selectedText.textContent = value;
            }

            if (currentColor) {
                currentColor.textContent = value;
            }

            if (popupImage && variantImg) {
                popupImage.src = variantImg;
                popupImage.srcset = variantImg;
            }

            updateButtonState(isAvailable);
            updateColorButton(this);

            if (originalSwatch) {
                const radio = originalSwatch.querySelector(
                    'input[value="' + value + '"]'
                );

                if (radio) {
                    radio.checked = true;

                    radio.dispatchEvent(
                        new Event('change', { bubbles: true })
                    );

                    radio.dispatchEvent(
                        new Event('click', { bubbles: true })
                    );
                }
            }
        });
    });

    document.querySelectorAll('.mobile-product-media-slider').forEach(function (slider) {
        new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 0,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            pagination: {
                el: slider.querySelector('.swiper-pagination'),
                clickable: true
            }
        });
    });

    const checkedRadio = document.querySelector('.swatch-color input:checked');

    if (checkedRadio) {
        const value = checkedRadio.value;

        if (selectedText) {
            selectedText.textContent = value;
        }

        if (currentColor) {
            currentColor.textContent = value;
        }

        const activeSwatch = document.querySelector(
            '.mobile-swatch[data-value="' + value + '"]'
        );

        document.querySelectorAll('.mobile-swatch').forEach(function (swatch) {
            swatch.classList.toggle(
                'active',
                swatch.dataset.value === value
            );
        });

        if (activeSwatch) {
            const variantImg = activeSwatch.dataset.variantImg;
            const isAvailable =
                activeSwatch.dataset.available === 'true';

            if (popupImage && variantImg) {
                popupImage.src = variantImg;
                popupImage.srcset = variantImg;
            }

            updateButtonState(isAvailable);
            updateColorButton(activeSwatch);
        }
    } else {
        const firstSwatch = document.querySelector('.mobile-swatch');

        if (firstSwatch) {
            updateButtonState(
                firstSwatch.dataset.available === 'true'
            );
            updateColorButton(firstSwatch);
        }
    }

    refreshMobileSwatches();

    document.querySelectorAll('.single-option-selector').forEach(function (select) {

        select.addEventListener('change', function () {

            setTimeout(function () {
                refreshMobileSwatches();
            }, 0);

        });

    });
});